(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-quotes-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('press-quotes-slider')) {
    class PressQuotesSlider extends HTMLElement {
      connectedCallback() {
        this.quotes = Array.from(this.querySelectorAll('[data-pqs-quote]'));
        this.logos = Array.from(this.querySelectorAll('[data-pqs-logo]'));
        this.index = Math.max(0, this.quotes.findIndex((q) => q.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.delay = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.focused = false;
        this.editing = false;
        this.inView = true;
        this.timer = null;

        this.onLogoClick = (event) => {
          const logo = event.target.closest('[data-pqs-logo]');
          if (!logo) return;
          this.goTo(this.logos.indexOf(logo));
          this.schedule();
        };
        this.onFocusIn = (event) => {
          this.focused = event.target.matches(':focus-visible');
        };
        this.onFocusOut = () => { this.focused = false; };
        this.onSelect = (event) => {
          const quote = event.target.closest('[data-pqs-quote]');
          if (!quote || !this.contains(quote)) return;
          this.editing = true;
          this.goTo(this.quotes.indexOf(quote));
          this.clear();
        };
        this.onDeselect = (event) => {
          if (!this.contains(event.target)) return;
          this.editing = false;
          this.schedule();
        };
        this.onVisibility = () => {
          if (document.hidden) this.clear();
          else this.schedule();
        };
        this.onMotionChange = () => this.schedule();

        this.addEventListener('click', this.onLogoClick);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.reduced.addEventListener('change', this.onMotionChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
          });
          this.observer.observe(this);
        }

        this.schedule();
      }

      disconnectedCallback() {
        this.clear();
        this.removeEventListener('click', this.onLogoClick);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.reduced.removeEventListener('change', this.onMotionChange);
        if (this.observer) this.observer.disconnect();
      }

      get paused() {
        return this.focused || this.editing || !this.inView || document.hidden;
      }

      goTo(index) {
        if (index < 0 || index >= this.quotes.length) return;
        this.index = index;
        this.quotes.forEach((quote, i) => {
          const active = i === index;
          quote.classList.toggle('is-active', active);
          if (active) quote.removeAttribute('aria-hidden');
          else quote.setAttribute('aria-hidden', 'true');
        });
        this.logos.forEach((logo, i) => {
          const active = i === index;
          logo.classList.toggle('is-active', active);
          if (active) logo.setAttribute('aria-current', 'true');
          else logo.removeAttribute('aria-current');
        });
      }

      clear() {
        clearTimeout(this.timer);
        this.timer = null;
      }

      schedule() {
        this.clear();
        if (!this.autoplay || this.quotes.length < 2 || this.reduced.matches || this.editing) return;
        this.timer = setTimeout(() => {
          if (!this.paused) this.goTo((this.index + 1) % this.quotes.length);
          this.schedule();
        }, this.delay);
      }
    }

    customElements.define('press-quotes-slider', PressQuotesSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
